// extracted by mini-css-extract-plugin
module.exports = {"FormAnt":"Form_FormAnt__0zhhz","ant-form-item":"Form_ant-form-item__P8Tvh","ant-form-item-label":"Form_ant-form-item-label__WJIXF"};